<template></template>

<script>
import { mapState } from "vuex";

export default {
  name: "Notificacao",
  computed: {
    ...mapState("generic", ["toast"]),
  },
  watch: {
    toast: {
      handler(value) {
        this.notifica(value);
      },
      deep: true,
    },
  },
  methods: {
    notifica(value) {
      if (value.type == "postApi" || value.type == "putApi")
        this.$toasted.show("Salvo com sucesso", {
          type: "success",
        });
      if (value.type == "postApiError" || value.type == "putApiErro") {
        this.$toasted.show("Não foi possível adicionar/modificar", {
          type: "error",
        });
        this.voltarParaTopo();
      }

      if (value.type == "removerTodosApiSucesso")
        this.$toasted.show("Removido com sucesso", {
          type: "success",
        });
      if (value.type == "removerTodosApiErro") {
        this.$toasted.show("Não foi possível remover", {
          type: "error",
        });
        this.voltarParaTopo();
      }

      if (value.type == "noPermission") {
        this.$toasted.show("Usuário sem permissão", {
          type: "error",
        });
        this.voltarParaTopo();
      }

      if (value.type == "falhaGenerica") {
        this.$toasted.show("Ops! Falha de servidor", {
          type: "error",
        });
        this.voltarParaTopo();
      }

      if (value.type == "messageError") {
        this.$toasted.show("Ops! Algo deu errado", {
          type: "error",
        });
        this.voltarParaTopo();
      }
    },
    voltarParaTopo() {
      window.scrollTo(0, 0);
    },
  },
};
</script>
